import type { Features } from 'generated/featureDefinitions'
import type { AllFeatureIds } from 'generated/featureIds.generated'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

type FeatureFlagMap = Record<string, AllFeatureIds>

const mapping: FeatureFlagMap = {
  timeoff_flexible_cycles: 'dev_timeoff_flexible_cycles',
  timeoff_blocked_periods: 'time_off_blocked_periods',
  timeoff_absence_duration_control: 'dev_timeoff_absence_duration',
}

export const useFeature = (feature: Features) => {
  const { loading, featureAvailability } = useFeatureAvailability(feature)

  if (hasFeature('dev_packaging_paywalls')) {
    return { loading: loading, enabled: featureAvailability.available }
  }

  const oldFeature = mapping[feature]

  if (oldFeature === undefined) {
    return { loading: loading, enabled: false }
  }

  return { loading: loading, enabled: hasFeature(oldFeature) }
}
